/**
 * @desc 获取树形目录
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(params: API.ucenter.sysUserTableau.getTableauTree.Params, options?: any) {
  return updateResponse(
    http(URL + `/sysUserTableau/getTableauTree`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
